import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import FormControl from '../FormControl/FormControl.js';
import { isEmailAddress } from '../Util/validations.js';

const Email = (_param)=> {
    var { id ='email' , 'data-t': dataT = 'email' , label , errorMessage , validations =[
        isEmailAddress
    ]  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "id",
        'data-t',
        "label",
        "errorMessage",
        "validations"
    ]);
    return React.createElement(FormControl, swcHelpers.extends({}, FormControl.defaultProps, {
        id: id,
        "data-t": dataT,
        type: "email",
        label: label,
        errorMessage: errorMessage,
        validations: validations
    }, rest));
};
var Email$1 = Email;

export { Email$1 as default };
//# sourceMappingURL=Email.js.map
